import React from "react";
import styled from "styled-components";

const ActivityImage = ({ image, inView, seller, offbeat, deal }) => {
  return (
    <OuterContainer>
      <InnerContainer url={image} inView={inView} />
      <MotivatorsContainer>
      {deal && 
        <SvgContainer className="svg__icon" title="Super deal">
          <use xlinkHref="/library/styles/images/svg-sprite-symbols.svg#svg-icon-deal-activity"/>
        </SvgContainer>
      }
      {seller && 
        <SvgContainer className="svg__icon" title="Best seller">
          <use xlinkHref="/library/styles/images/svg-sprite-symbols.svg#svg-icon-best-seller-activity"/>
        </SvgContainer>
      } 
      {offbeat && 
        <SvgContainer className="svg__icon" title="Off-beat">
          <use xlinkHref="/library/styles/images/svg-sprite-symbols.svg#svg-icon-offbeat-activity"/>
        </SvgContainer>
      }
      </MotivatorsContainer>
    </OuterContainer>
  );
};

const MotivatorsContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  display:flex;
  justify-content: flex-start;
  align-items: center;
`;
const SvgContainer = styled.svg`
  height: 1.75rem;
  width: 5.35rem;
  margin-right: 0.25rem;
`;

const OuterContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: calc(100% / 1.618);
  background-color: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
  overflow: hidden;
`;
export const InnerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
  background-image: url(${props => (props.inView ? props.url : "")});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-origin: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  transition: transform 0.3s ease-in-out, background-image 0.3s ease-in-out;
`;

export default ActivityImage;
